<script setup lang="ts">
defineProps<{
  variant?: 'primary' | 'outline' | 'ghost';
  disabled?: boolean;
  type?: 'button' | 'submit';
}>();
</script>

<template>
  <button
    class="entr-button"
    :class="`is-${variant ?? 'primary'}`"
    :disabled="disabled"
    :type="type ?? 'button'"
  >
    <span><slot /></span>
    <span v-if="$slots.icon" class="icon"><slot name="icon" /></span>
  </button>
</template>

<style scoped>
.entr-button {
  min-width: 280px;
  height: 96px;
  padding: 0 48px;
  border-radius: 9999px;
  display: inline-flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  line-height: 1;
  color: var(--entr-text);
  transition:
    transform 150ms ease-out,
    opacity 200ms ease,
    background 200ms ease;
}

.entr-button:active:not(:disabled) {
  transform: scale(0.97);
}

.entr-button:disabled {
  opacity: 0.38;
}

.is-primary {
  background: var(--entr-button-bg);
}

.is-outline {
  border: 2px solid var(--entr-text);
  background: transparent;
}

.is-ghost {
  min-width: 96px;
  padding: 0 16px;
  background: transparent;
}

.icon {
  display: inline-flex;
}
</style>
